import { IPMChart, IPMChartDpc, IPMChartDpcExec, IPMChartWeeklyReport } from '@/ship/Models/IProjectManagement';
import { ChartVersion, Structure } from '@/ship/Models/ProjectManagement';

import User from '@/ship/Models/User';
import { StoreOptions } from 'vuex';
import { namespace } from 'vuex-class';
import actions from './Actions';
import getters from './Getters';
import mutations from './Mutations';

export interface ProjectManagementState {
    chart: IPMChart | null;
    editChart: IPMChart | null;
    chartVersion: ChartVersion | null;
    chartVersionTasks: Structure[];
    users: User[];
    dpcList: IPMChartDpc[];
    dpcExecList: IPMChartDpcExec[];
    weeklyReport: IPMChartWeeklyReport | null;
}

export const state: ProjectManagementState = {
    chart: null,
    editChart: null,
    chartVersion: {} as ChartVersion,
    chartVersionTasks: [],
    users: [],
    dpcList: [],
    dpcExecList: [],
    weeklyReport: null,
};

export const root: StoreOptions<ProjectManagementState> = {
    state,
    actions,
    getters,
    mutations,
};

export const ProjectManagementStore = namespace('projectManagement');
export const ProjectManagementAction = ProjectManagementStore.Action;
export const ProjectManagementGetter = ProjectManagementStore.Getter;
export const ProjectManagementMutation = ProjectManagementStore.Mutation;
export const ProjectManagementState = ProjectManagementStore.State;

export default root;
